import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { SideBarMenu } from "../../../../stories/SideBarMenu/SideBarMenu";
import {
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
} from "../../../../constant/imagePath";

import classes from "./DashboardScreen.module.css";
import { DashboardSidebarWithCalendar } from "../../../../stories/DashboardSidebarWithCalendar/DashboardSidebarWithCalendar";
import TodoComp from "../../../../components/CoachFlow/CoachDashboard/Todo/Todo";
import DashboardMobileScreen from "./DashboardMobileScreen";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { useHistory, useLocation } from "react-router-dom";

function DashboardScreenDesktop() {
  const history = useHistory();
  const location = useLocation();
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      onClick: () => history.push("/todo"),
      activeText: "todo",
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      onClick: () => history.push("/notifications"),
      activeText: "notifications",
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",
      onClick: () => history.push("/schedule"),
      activeText: "schedule",
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",
      onClick: () => history.push("/chat"),
      activeText: "chat",
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => history.push("/reviews"),
      activeText: "reviews",
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      onClick: () => history.push("/insights"),
      activeText: "insights",
    },
  ];

  return (
    <div className={[classes.DashboardScreen].join(" ")}>
      <Container fluid className={`p-0 ${classes.container}`}>
        <Row className={`g-0 ${classes.row}`}>
          <Col md={12}>
            <div className="d-flex">
              <SideBarMenu
                logo={ShortLogo}
                items={sidebarMenus}
                state={location?.pathname.split("/")[1]}
                customStyle={{ minHeight: "100vh", height: "auto" }}
              />
              <div className={classes.content}>
                <TodoComp />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default function DashboardScreen() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <DashboardMobileScreen /> : <DashboardScreenDesktop />;
}
